const initState = {
  isAuthenticate: localStorage.getItem('access_token'),
  userLogin: {},
  userConfig: {},
  package: {},
  subs: {},
  notif: [],
  contactUsList: [],
  error: false
}

const reducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_AUTHENTICATE':
      return {...state, isAuthenticate: action.payload}
    case 'SET_USER':
      return {...state, userLogin: action.payload}
    case 'SET_USER_CONFIG':
      return {...state, userConfig: action.payload}
    case 'SET_PACKAGE':
      return {...state, package: action.payload}
    case 'SET_SUBS':
      return {...state, subs: action.payload}
    case 'SET_NOTIF':
      return {...state, notif: action.payload}
    case 'SET_CONTACT_US':
      return {...state, contactUsList: action.payload}
    case 'SET_ERROR':
      return {...state, error: true}
    default : 
      return state
  }
}

export default reducer